import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import { MessageSquare } from "lucide-react";
import { toast } from "sonner";
import { smsReminderPref, setSmsReminderPref } from "../lib/api";

// Reminders panel: weekly text with what's expiring (Mondays, plus an urgent nudge ≤3 days out). Needs a verified mobile.
export const SmsReminderToggle = () => {
  const qc = useQueryClient();
  const { data } = useQuery({ queryKey: ["sms-reminders"], queryFn: smsReminderPref, staleTime: 60_000 });
  const set = useMutation({ mutationFn: setSmsReminderPref, onSuccess: (r) => { qc.setQueryData(["sms-reminders"], r); toast.success(r.enabled ? "We'll text you on Mondays when something is coming up" : "Text reminders off"); }, onError: (e) => toast.error(e?.response?.data?.detail || "Couldn't change that") });
  if (!data) return null;
  return (
    <label className="mt-3 flex items-start gap-2 rounded-xl border border-border bg-card p-3 text-sm cursor-pointer" data-testid="sms-reminders-toggle">
      <input type="checkbox" className="mt-1 accent-primary" checked={!!data.enabled} disabled={!data.phone_verified} onChange={(e) => set.mutate(e.target.checked)} data-testid="sms-reminders-checkbox" />
      <span className="min-w-0">
        <span className="flex items-center gap-1.5 font-medium"><MessageSquare className="h-3.5 w-3.5 text-primary" /> Text me what's expiring</span>
        <span className="block text-xs text-muted-foreground mt-0.5" data-testid="sms-reminders-hint">
          {data.phone_verified
            ? `A short text to ${data.phone_hint} on Monday mornings when renewals or expiries fall in the next 7 days — and sooner if something is 3 days out. ${data.upcoming} coming up now.`
            : "Verify your mobile number under Security → Text messages to turn this on."}
        </span>
      </span>
    </label>
  );
};
